/**
 * @file location-page
 * @author
 */

import React from 'react';
import Cascader from 'antd/lib/cascader';
import {recordProxy} from '../../../util';
import {
    ICompLocationPickerProps as IProps,
    ICompLocationPickerState as IState,
} from '../locationResInterface';
class CompLocationPicker extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);
        this.state = {
            locArr: this.handleData(props.locArr),
            multiArr: [[], [], []],
            locSelect: []
        };
    }
    handleData(data) {
        // 针对每个省下面的市和区增加「全部」选项
        data.length > 0 && data.map(val => {
            if (!val.children || val.children.length === 0) {
                // val.children.unshift({name: '全部', children: [{name: '全部'}]});
                val.children = [{
                    name: '全部', value: '全部', label: '全部',
                    children: [{name: '全部', value: '全部', label: '全部'}]}];
            }
            val.children.map(c => {
                if (c.children && c.children.length > 1) {
                    c.children.unshift({name: '全部', value: '全部', label: '全部'});
                } else {
                    c.children = [{name: '全部', value: '全部', label: '全部'}];
                }
            });
        });
        return data;
    }
    componentDidMount() {
        const {prov, city} = this.props.userPosition;
        const district = this.props.userPosition.district || '全部';
        // const data = {prov: '湖北省', city: '武汉市', district: '江夏区'};
        const data = {prov, city, district};
        this.initState(data);
    }
    initState(data) {
        const {prov, city, district} = data;
        this.setState({locSelect: [prov, city, district]});
    }
    onChange(value) {
        const {srcid, pageType, title, tag} = this.props;
        const pointParam = {
            pageType,
            srcid,
            value,
            title,
            tag
        };
        recordProxy('locationPicker', 'change', JSON.stringify(pointParam));
        this.setState({locSelect: value});
        this.props.onPickerChange({prov: value[0], city: value[1] || '', district: value[2]});
    }

    handleEmptyArr = (value) => {
        const arrLen = value.length;
        if (value[arrLen - 1] === '') {
            value.pop();
            return this.handleEmptyArr(value);
        } else {
            return value;
        }
    };
    render() {
        const {locArr, userPosition} = this.props;
        const {prov, city} = userPosition;
        const district = userPosition.district || '全部';
        const locSelect = [prov, city, district];
        const pickerValue = this.handleEmptyArr(locSelect);
        return (<div className="location-picker">
            <Cascader
                placeholder="请选择"
                options={locArr}
                onChange={this.onChange.bind(this)}
                // changeOnSelect
                value={pickerValue}
                style={{width: '260px', fontSize: '15px'}}
            />
        </div>);
    }
}

export default CompLocationPicker;